// @flow
import * as React from 'react';
import { connect } from 'react-redux';
import ProfileFollowing from 'app/common/react/components/profile/ProfileFollowing/ProfileFollowing';
import type { State } from 'app/common/redux/types';
import type { Viewer } from 'app/packages/pinterest-flow-types/viewer';
import withResource from 'app/common/lib/react/withResource';
import { compose } from 'redux';

type Props = {
  data: Object,
  following: Object,
  params: { username: string },
  user: Object,
  viewer: Viewer,
};

function FollowingPeopleContainer(props: Props) {
  const { data, following, params, viewer, user } = props;
  return (
    <ProfileFollowing
      following={following}
      data={data}
      params={params}
      viewer={viewer}
      user={user}
    />
  );
}

export default compose(
  // $FlowFixMe: new errors found from flow 0.96 upgrade
  connect((state: State): { viewer: Viewer } => ({ viewer: state.viewer })),
  withResource({
    name: 'UserFollowingResource',
    key: 'following',
    options: ({ params }) => ({
      hide_find_friends_rep: true,
      username: params.username,
    }),
  }),
  withResource({
    name: 'UserResource',
    key: 'user',
    options: ({ params }) => ({
      username: params.username,
      field_set_key: 'profile',
    }),
  }),
)(FollowingPeopleContainer);
